import $ from 'jquery';
import { Button, Input } from 'antd';
import React, { useEffect, useState } from 'react';
import { CloseCircleOutlined, DownOutlined, UploadOutlined, UpOutlined } from '@ant-design/icons';
import ModalImage from 'react-modal-image';
import { useSelector } from 'react-redux';
import { femaleImg, maleImg } from '../../scripts/cy-css';

const ImageUpload = () => {
  const treeImages = useSelector((state) => state.tree.images);
  const currentNode = useSelector((state) => state.tree.currentNode);
  const [uploadImg, setUploadImg] = useState(null);
  const [stateImgUrl, setStateImgUrl] = useState(null);
  // const [cyNodeCss, setCyNodeCss] = useState(null);

  // check null and get default url
  const verifyUrl = (url) => {
    // // debug-console.log('verifyUrl:', url);
    if (!url || url === '') {
      if (currentNode.gender === 'f') {
        url = femaleImg;
      } else {
        url = maleImg;
      }
    }
    // // debug-console.log('verifyUrl:->', url);
    return url;
  };

  // important: determine which image is displayed
  const getHideOrShowClass = (nodeImage) => {
    if (nodeImage === uploadImg) {
      // // debug-console.log('getHideOrShowClass: show1: uploading image');
      return '';
    }
    if (nodeImage === stateImgUrl && !uploadImg) {
      // // debug-console.log('getHideOrShowClass: show2: current Node image', nodeImage);
      return '';
    }
    // // debug-console.log('getHideOrShowClass: hide: ', image);
    return 'hide';
  };

  const previewPhoto = () => {
    const input = document.getElementById('photoupload');
    const { files } = input;
    if (files) {
      const [file] = files;
      // debug-console.log('preview Photo: uploaded file:', files);
      if (file) {
        const fileReader = new FileReader();
        // const preview = document.getElementById('nodeImg');
        fileReader.onload = (event) => {
          // // debug-console.log('previewPhoto: onLoad, event=', event);
          // preview.setAttribute('src', event.target.result);
          displayUploadedImage(event.target.result);
        };
        $('#fileName').text(file?.name);
        $('#uploadInfo').show();
        fileReader.readAsDataURL(file);
      }
    }
  };

  // url is base64 uploaded image content: 'data:image/jpeg;base...'
  const displayUploadedImage = (url) => {
    // debug-console.log(      '++++ display UploadedImage: url=',      url?.startsWith('http') ? url : url?.substring(0, 20),    );
    setUploadImg(url);
  };

  const clearUploadImg = () => {
    // // debug-console.log('Clear UploadImg');
    $('#fileName').text('');
    $('#uploadInfo').hide();
    const uploadInput = document.getElementById('photoupload');
    uploadInput.value = null;
    setUploadImg(null);
  };

  const createImageSet = () => {
    const imgSet = new Set(treeImages);
    imgSet.add(maleImg);
    imgSet.add(femaleImg);

    if (uploadImg) {
      imgSet.add(uploadImg);
    }

    const arr = Array.from(imgSet);
    // debug-console.log('images: ', arr.length);
    return arr;
  };

  // const images = createImageSet();

  useEffect(() => {
    // debug-console.log('[Use Effect] ImageUpload: currentNode=', currentNode.name);
    if (stateImgUrl !== currentNode.img && currentNode.img) {
      // a new node is selected:
      clearUploadImg();
    }
    setStateImgUrl(verifyUrl(currentNode.img));
    // const currentNodeCss = getNodeCss(currentNode.id);
    // setCyNodeCss(currentNodeCss);
    // // debug-console.log('[Use Effect] node css=', currentNodeCss);
  }, [currentNode]);

  return (
    <div id="imageUpload">
      <div className="left-full">
        <div id="uploadDiv">
          <table>
            <tbody>
              <tr>
                <td>Ảnh</td>
              </tr>
              <tr>
                <td>
                  <Button
                    id="uploadBtn"
                    icon={<UploadOutlined />}
                    onClick={() => document.getElementById('photoupload').click()}
                  >
                    Upload
                  </Button>
                  <input
                    id="photoupload"
                    type="file"
                    accept="image/*"
                    onChange={previewPhoto}
                    className="hide"
                  />
                </td>
              </tr>
            </tbody>
          </table>
        </div>

        <div id="imgDiv" className="right">
          <div className="left-full">
            <div id="imgs">
              {createImageSet().map((image, index) => (
                <div key={`img-${index}`}>
                  <ModalImage
                    alt={currentNode.name}
                    className={getHideOrShowClass(image)}
                    small={image}
                    medium={image}
                    large={image}
                  />
                </div>
              ))}
            </div>
            {/* <div id="height-update">
              <Space direction="vertical">
                <UpOutlined></UpOutlined>

                <DownOutlined></DownOutlined>
              </Space>
            </div> */}
          </div>
          <div id="width-update" className="left-full"></div>
        </div>
      </div>

      <div id="uploadInfo">
        <span id="fileName" />
        <CloseCircleOutlined id="clearUploadBtn" onClick={clearUploadImg} />
      </div>
      {/* {isAdmin() && ( */}
      {/* <TextArea
        id="cyNodeCss"
        style={{ wordWrap: 'break-word', height: '220px' }}
        value={JSON.stringify(cyNodeCss)}
      /> */}
    </div>
  );
};

export default ImageUpload;
